<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getQueryString } from "@/utils/fun";
export default {
  mounted() {
    if (['en_us','zh_cn'].includes(getQueryString("language"))) {
      localStorage.setItem("language", getQueryString("language"));
    }
    this.$i18n.locale = localStorage.getItem("language") || "zh_cn";
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  border: 0;
  margin: 0;
}
.langChange {
  position: absolute;
  right: 20px;
  top: 20px;
}

.Myfooter {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 5px;
    color: #959595;
    cursor: pointer;
    a {
      color: #959595;
      text-decoration: none;
    }
  }
}
</style>
